import { FC } from "react";
import { useTranslation } from "react-i18next";
import ProductUploadImages from "../product-upload-image/product-upload-image";
import ProductNamePrice from "../product-name-price/product-name-price";
import { ProductDetailWrapper } from "../product-detail/product-detail.styled";

const ServiceDetail: FC = () => {
  const { t } = useTranslation();

  return (
    <ProductDetailWrapper>
      <div className="title">
        <div className="text">
          {t("productComponent.service.detail.title")}
        </div>
      </div>
      <div className="content">
        <ProductUploadImages />
        <ProductNamePrice variant="service" />
      </div>
    </ProductDetailWrapper>
  );
};

export default ServiceDetail;
